import type { Role } from '@/entities/user';

/** List/detail: admin + warehouse_manager. Fulfilment status PATCH is admin-only (`RoleGate`). */
export const ordersAccessRoles = ['admin', 'warehouse_manager'] as const satisfies readonly Role[];
